import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";

import { Button, IButtonProps } from "@livechat/design-system";

interface IProps extends IButtonProps, RouteComponentProps {
  to: string;
}

const LinkButton: React.FC<IProps> = ({ ...props }) => {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { history, location, match, staticContext, to, onClick, ...rest } = props;

  return (
    <Button
      {...rest}
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onClick={(event: any) => {
        if (onClick) {
          onClick(event);
        }
        history.push(to);
      }}
    />
  );
};

export default withRouter(LinkButton);
